<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item :label="$t('实施人类型')" prop="taskImplementType">
                <a-select :placeholder="$t('请选择实施人类型')" v-model="model.taskImplementType" @change="typeChange">
                  <a-select-option :value="0">{{ $t('指定班组') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('直接指定实施人员') }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" v-if="model.taskImplementType == 0">
              <a-form-model-item :label="$t('选择班组')" prop="taskGroupId">
                <!-- <a-cascader :options="deptList" :field-names="fieldNames" placeholder="请选择班组" change-on-select @change="onChange" /> -->
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择班组')" v-model="model.taskGroupId">
                  <a-select-option :value="item.id" v-for="item in groupList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24" v-else-if="model.taskImplementType == 1">
              <a-form-model-item :label="$t('选择人员')" prop="taskPeopleId">
                <a-select show-search option-filter-prop="children" :placeholder="$t('请选择人员')" v-model="model.taskPeopleId">
                  <a-select-option :value="item.id" v-for="item in personnelList" :key="item.id">{{item.name}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('备注')" prop="remark">
                <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  export default {
    // mixins: [JeecgListMixin],
    name: 'inspectionTaskAssignModal',
    components: {},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          editState: "/jeecg-engineering/inspection/inspectionTask/editState",
          queryById: "/jeecg-engineering/inspection/inspectionTask/queryById",
          userList: "/sys/user/list",
          deptList: "/sys/sysDepart/queryMyDeptTreeList",
          inspectionTeam: "/jeecg-engineering/engineering/inspectionTeam/list",
          inspectionUser: "/jeecg-engineering/inspection/inspectionUser/list",
        },
        personnelList: [],
        deptList: [],
        fieldNames: {
          label: 'departName',
          value: 'orgCode',
          children: 'children'
        },
        groupList: []
      }
    },
    computed: {
      validatorRules() {
        return {
          taskImplementType: [{
            required: true,
            message: this.$t('请选择实施人类型'),
            trigger: 'change'
          }],
          planName: [{
            required: true,
            message: this.$t('请输入巡检方案名称'),
            trigger: 'blur'
          }],
          taskGroupId: [{
            required: true,
            message: this.$t('请选择班组'),
            trigger: 'change'
          }],
          taskPeopleId: [{
            required: true,
            message: this.$t('请选择人员'),
            trigger: 'change'
          }]
        }
      },
    },
    methods: {
      getPersonnelList(){
        this.personnelList = [];
        getAction(this.url.inspectionUser,{pageSize: 999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.personnelList.push({
                id: item.userId,
                name: item.userName
              });
            });
          }
        });
      },
      getDeptList(){
        this.groupList = [];
        getAction(this.url.inspectionTeam,{pageSize: 999}).then(res=>{
          if(res.success){
            res.result.records.forEach(item=>{
              this.groupList.push({
                id: item.id,
                name: item.teamName
              });
            });
          }
        })
      },
      typeChange(e){
        if(e == 0){
          this.model.taskPeopleId = '';
          this.getDeptList();
        }else{
          this.model.taskGroupId = '';
          this.getPersonnelList();
        }
      },
      init(row){
        this.visible = true;
        this.title = this.$t('任务分派');
        this.model = JSON.parse(JSON.stringify(row));
        this.typeChange(this.model.taskImplementType)
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        if(this.model.taskImplementType == 0){
          this.model.taskImplementName = this.groupList.find(g=>g.id == this.model.taskGroupId).name;
        }else{
          this.model.taskImplementName = this.personnelList.find(p=>p.id == this.model.taskPeopleId).name;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            postAction(this.url.editState, this.model).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
      onChange(e,row){
        debugger
        this.model.taskGroupId = e;
      }
    }
  }
</script>